export const treeFilterProcessor = ({ query, key, filterData, filter }) => {
	let active = false;
	const activeOptions = [];

	const sortSelection = (a, b) => {
		if(a.selected && !b.selected) {
			return -1;
		}
		else if(!a.selected && b.selected) {
			return 1;
		}
		return 0;
	};

	const processOptions = (options => {
		return (options || []).map(option => {
			var values = typeof query[key] === 'object' ? query[key] : ((query && query[key]) ? [query[key]] : []);
			const selected = values.includes(option[filter.valueKey].toString());
			if(selected) {
				active = true;
				activeOptions.push(option);
			}
	
			return {
				...option,
				value: option[filter.valueKey],
				label: option[filter.labelKey ?? 'name'],
				children: option.children ? processOptions(option.children).sort(sortSelection) : null,
				selected: selected,
			};
		})
	})

	const options = processOptions(filterData[key]).sort(sortSelection);

	return {
		...filter,
		key,
		active,
		options,
		activeOptions,
		sumText: activeOptions.map(o => o[filter.labelKey ?? 'name']).join(', '),
	}
}